const WORDS = ["Design estratégico", "Impressão digital", "Comunicação visual", "Adesivos e etiquetas", "E-commerce", "Materiais para empresas"];

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {WORDS.map((w, i) => (
      <span key={w} className="flex items-center font-display text-4xl sm:text-6xl whitespace-nowrap uppercase px-6 sm:px-10">
        <span className={i % 2 ? "italic text-lime" : ""}>{w}</span>
        <svg viewBox="0 0 20 20" className="ml-12 sm:ml-20 h-4 w-4 text-lime"><circle cx="10" cy="10" r="8" fill="none" stroke="currentColor" /><path d="M10 0v20M0 10h20" stroke="currentColor" /></svg>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section data-testid="editorial-marquee" className="bg-ink text-paper py-10 sm:py-14 overflow-hidden">
    <div className="marquee-track flex w-max">
      <Row />
      <Row hidden />
    </div>
  </section>
);
